const CODECARD = {
    /*********************
    * Reload
    *********************/
    reload(clientId) {
        setTimeout(() => {
            XHR.load({
                nodeIds:      ['xhr-grid'],
                functionCall: [FILEPOND.onReady, NICESELECT.onReady],
                animationOn:  true
            });
        }, 500);
    },
    /*********************
    * Archive
    *********************/
    archive(clientId) {
        OVERLAY.loading();
        let getUrl   = window.location;
        let baseUrl  = getUrl.protocol + '//' + getUrl.hostname + '/';
        let formData = 'client_id=' + clientId + '&nonce=' + encodeURIComponent(ieNonce);
        let handler  = 'handler.XHR.php?handler=archive-codecard';
        let xhr      = new XMLHttpRequest();
        xhr.open('POST', baseUrl + 'wp-content/themes/atlas-novus-child/inc/' + handler, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = (e) => {
            if (xhr.readyState === 4) {
                document.getElementById('overlay-loading').remove();
                if (xhr.status === 200) {
                    swal({
                        title:               'Karte wurde archiviert',
                        text:                'Sie finden die Karte weiterhin unter dem Status "archiviert".',
                        icon:                'success',
                        closeOnClickOutside: true,
                        closeOnEsc:          true,
                        buttons:             'ok'
                    });
                } else {
                    swal({
                        title:               'Es ist ein Fehler aufgetreten',
                        text:                'Bitte versuchen Sie es erneut, oder wenden Sie sich an den Webseiten-Administrator.',
                        icon:                'error',
                        closeOnClickOutside: true,
                        closeOnEsc:          true,
                        buttons:             'ok'
                    });
                }
            }
        };
        xhr.onerror = (e) => {
            document.getElementById('overlay-loading').remove();
            swal({
                title:               'Es ist ein Fehler aufgetreten',
                text:                'Bitte versuchen Sie es erneut, oder wenden Sie sich an den Webseiten-Administrator.',
                icon:                'error',
                closeOnClickOutside: true,
                closeOnEsc:          true,
                buttons:             'ok'
            });
        };
        xhr.send(formData);
        console.log(xhr);
        CODECARD.reload(clientId);
    },
    /*********************
    * Unarchive
    *********************/
    unarchive(clientId) {
        OVERLAY.loading();
        let getUrl   = window.location;
        let baseUrl  = getUrl.protocol + '//' + getUrl.hostname + '/';
        let formData = 'client_id=' + clientId + '&nonce=' + encodeURIComponent(ieNonce);
        let handler  = 'handler.XHR.php?handler=unarchive-codecard';
        let xhr      = new XMLHttpRequest();
        xhr.open('POST', baseUrl + 'wp-content/themes/atlas-novus-child/inc/' + handler, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = (e) => {
            if (xhr.readyState === 4) {
                document.getElementById('overlay-loading').remove();
                if (xhr.status === 200) {
                    swal({
                        title:               'Die Karte ist aktiv',
                        text:                'Die Karte wurde aus dem Archiv genommen und kann wieder regulär bearbeitet werden.',
                        icon:                'success',
                        closeOnClickOutside: true,
                        closeOnEsc:          true,
                        buttons:             'ok'
                    });
                } else {
                    swal({
                        title:               'Es ist ein Fehler aufgetreten',
                        text:                'Bitte versuchen Sie es erneut, oder wenden Sie sich an den Webseiten-Administrator.',
                        icon:                'error',
                        closeOnClickOutside: true,
                        closeOnEsc:          true,
                        buttons:             'ok'
                    });
                }
            }
        };
        xhr.onerror = (e) => {
            document.getElementById('overlay-loading').remove();
            swal({
                title:               'Es ist ein Fehler aufgetreten',
                text:                'Bitte versuchen Sie es erneut, oder wenden Sie sich an den Webseiten-Administrator.',
                icon:                'error',
                closeOnClickOutside: true,
                closeOnEsc:          true,
                buttons:             'ok'
            });
        };
        xhr.send(formData);
        console.log(xhr);
        CODECARD.reload(clientId);
    },
    /*********************
    * Delete Upload
    *********************/
    deleteProfile(clientId) {
        swal({
            title:  'Profil wirklich löschen?',
            text:   'Wollen Sie das Profil wirklich löschen? Die Aktion kann nicht rückgängig gemacht werden.',
            icon:   'warning',
            closeOnClickOutside: true,
            closeOnEsc: true,
            buttons: {
                cancel: {
                    text:       'abbrechen',
                    value:      null,
                    visible:    true,
                    className:  '',
                    closeModal: true,
                },
                confirm: {
                    text:       'löschen',
                    value:      true,
                    visible:    true,
                    className:  '',
                    closeModal: true
                }
            }
        }).then(accept => {
            if (accept) {
                OVERLAY.loading();
                let getUrl   = window.location;
                let baseUrl  = getUrl.protocol + '//' + getUrl.hostname + '/';
                let formData = 'client_id=' + clientId + '&nonce=' + encodeURIComponent(ieNonce);
                let handler  = 'handler.XHR.php?handler=delete-profile';
                let xhr      = new XMLHttpRequest();
                xhr.open('POST', baseUrl + 'wp-content/themes/atlas-novus-child/inc/' + handler, true);
                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                xhr.onload = (e) => {
                    if (xhr.readyState === 4) {
                        document.getElementById('overlay-loading').remove();
                        if (xhr.status === 200) {
                            swal({
                                title:               'Profil wurde gelöscht',
                                text:                'Bitte laden Sie eine neue Auswertung hoch.',
                                icon:                'success',
                                closeOnClickOutside: true,
                                closeOnEsc:          true,
                                buttons:             'ok'
                            });
                        } else {
                            swal({
                                title:               'Es ist ein Fehler aufgetreten',
                                text:                'Bitte versuchen Sie es erneut, oder wenden Sie sich an den Webseiten-Administrator.',
                                icon:                'error',
                                closeOnClickOutside: true,
                                closeOnEsc:          true,
                                buttons:             'ok'
                            });
                        }
                    }
                };
                xhr.onerror = (e) => {
                    document.getElementById('overlay-loading').remove();
                    swal({
                        title:               'Es ist ein Fehler aufgetreten',
                        text:                'Bitte versuchen Sie es erneut, oder wenden Sie sich an den Webseiten-Administrator.',
                        icon:                'error',
                        closeOnClickOutside: true,
                        closeOnEsc:          true,
                        buttons:             'ok'
                    });
                };
                xhr.send(formData);
                console.log(xhr);
                CODECARD.reload(clientId);
            }
        });
    },
    /*********************
    * Send Upload
    *********************/
    sendProfile(clientId, usage = 'standard') {
        if (usage == 'personalauswahl') {
            var text = `Wollen Sie das hochgeladene Profil wirklich an den Auftraggeber verschicken? Der AG erhält eine automatisierte Mail mit dem Link zum Download. Das hochgeladene Profil kann im Anschluss nicht mehr gelöscht/ausgetauscht werden.
             
             WICHTIG! Stellen Sie unbedingt sicher, dass das Profil NICHT den ausgefüllten Fragebogen beinhaltet!
             
             Folgende Mails auf DE oder EN werden verschickt:
             
             DE:
             Wir möchten Sie darüber informieren, dass die Auswertung des in Auftrag gegebenen I-E-Profils abgeschlossen ist.
             Das Ergebnis des Ich-Entwicklungs-Profil finden Sie hier: geschützter PDF-Download (Link)
             Hinweis: Das Dokument ist passwortgeschützt. Das Passwort ist eine Kombination aus den ersten beiden Buchstaben des Vornamens und Nachnamens von dem/der Ausfüller:in und dem aktuellen Jahr (z.B. Max Mustermann 2022: MaMu-22).
             
             EN:
             We would like to inform you that the evaluation of the commissioned E-D-Profile questionnaire has been completed.
             The results of the Self-Development Profile can be found here: protected PDF download (link)
             The document is password-protected. The password consists of the first two letters of the first name and last name of the respondent, followed by the current year (e.g., John Doe 2022: JoDo-22).
             `;
        } else {
            var text = `Wollen Sie das hochgeladene Profil wirklich an den Endkunden verschicken? Der Empfänger erhält eine automatisierte Mail mit dem Link zum Download. Das hochgeladene Profil kann im Anschluss nicht mehr gelöscht/ausgetauscht werden.
             
             Folgende Mails auf DE oder EN werden verschickt:
             
             DE:
             Guten Tag __Platzhalter__,
             wir möchten Sie darüber informieren, dass die Auswertung Ihres I-E-Profil-Fragebogens abgeschlossen ist.
             Ihr Ich-Entwicklungs-Profil finden Sie hier: geschützter PDF-Download (Link)
             Hinweis: Das Dokument ist passwortgeschützt. Das Passwort ist eine Kombination aus den ersten beiden Buchstaben Ihres Vornamens und Nachnamens und dem aktuellen Jahr (z.B. Max Mustermann 2022: MaMu-22).
             
             EN:
             Hello __Placeholder__,
             we would like to inform you that the evaluation of your E-D-Profile questionnaire has been completed.
             You can find your Self-Development Profile here: protected PDF download (link)
             Please note that the document is password-protected. The password is a combination of the first two letters of your first name, your last name, and the current year (e.g., John Doe 2022: JoDo-2022).
             `;
        }
        swal({
            title:  'Profil wirklich verschicken?',
            text:   text,
            icon:   'warning',
            closeOnClickOutside: true,
            closeOnEsc: true,
            buttons: {
                cancel: {
                    text:       'abbrechen',
                    value:      null,
                    visible:    true,
                    className:  '',
                    closeModal: true,
                },
                confirm: {
                    text:       'verschicken',
                    value:      true,
                    visible:    true,
                    className:  '',
                    closeModal: true
                }
            }
        }).then(accept => {
            if (accept) {
                OVERLAY.loading();
                let getUrl   = window.location;
                let baseUrl  = getUrl.protocol + '//' + getUrl.hostname + '/';
                let formData = 'client_id=' + clientId + '&nonce=' + encodeURIComponent(ieNonce);
                let handler  = 'handler.XHR.php?handler=send-profile';
                let xhr      = new XMLHttpRequest();
                xhr.open('POST', baseUrl + 'wp-content/themes/atlas-novus-child/inc/' + handler, true);
                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                xhr.onload = (e) => {
                    if (xhr.readyState === 4) {
                        document.getElementById('overlay-loading').remove();
                        if (xhr.status === 200) {
                            swal({
                                title:               'Profil wurde verschickt',
                                text:                'Der Empfänger hat eine automatisierte Mail mit dem Link zum Download erhalten.',
                                icon:                'success',
                                closeOnClickOutside: true,
                                closeOnEsc:          true,
                                buttons:             'ok'
                            });
                        } else {
                            swal({
                                title:               'Es ist ein Fehler aufgetreten',
                                text:                'Bitte versuchen Sie es erneut, oder wenden Sie sich an den Webseiten-Administrator.',
                                icon:                'error',
                                closeOnClickOutside: true,
                                closeOnEsc:          true,
                                buttons:             'ok'
                            });
                        }
                    }
                };
                xhr.onerror = (e) => {
                    document.getElementById('overlay-loading').remove();
                    swal({
                        title:               'Es ist ein Fehler aufgetreten',
                        text:                'Bitte versuchen Sie es erneut, oder wenden Sie sich an den Webseiten-Administrator.',
                        icon:                'error',
                        closeOnClickOutside: true,
                        closeOnEsc:          true,
                        buttons:             'ok'
                    });
                };
                xhr.send(formData);
                console.log(xhr);
                CODECARD.reload(clientId);
            }
        });
    },
    /*********************
    * Resend Code
    *********************/
    resendCode(clientId) {
        OVERLAY.loading();
        let getUrl   = window.location;
        let baseUrl  = getUrl.protocol + '//' + getUrl.hostname + '/';
        let formData = 'client_id=' + clientId + '&nonce=' + encodeURIComponent(ieNonce);
        let handler  = 'handler.XHR.php?handler=resend-code';
        let xhr      = new XMLHttpRequest();
        xhr.open('POST', baseUrl + 'wp-content/themes/atlas-novus-child/inc/' + handler, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = (e) => {
            if (xhr.readyState === 4) {
                document.getElementById('overlay-loading').remove();
                if (xhr.status === 200) {
                    swal({
                        title:               'Code versendet',
                        text:                'Der Kunde erhält eine Mail mit den Zugangsdaten und einer Anleitung. Sollte der Kunde die Mail weiterhin nicht in seinem Postfach finden, dann kontrollieren Sie die E-Mail-Adresse oder weisen Sie auf die Spam- und Junk-Ordner hin. Andernfalls kann der Zugangscode-Generator erneut benutzt werden oder Sie teilen die Zugangsdaten persönlich mit. Der Zugang besteht aus Code und E-Mail-Adresse und der Fragebogen ist unter "www.i-e-profil.de/fragebogen/" zu erreichen.',
                        icon:                'success',
                        closeOnClickOutside: true,
                        closeOnEsc:          true,
                        buttons:             'ok'
                    });
                } else {
                    swal({
                        title:               'Es ist ein Fehler aufgetreten',
                        text:                'Bitte versuchen Sie es erneut, oder wenden Sie sich an den Webseiten-Administrator.',
                        icon:                'error',
                        closeOnClickOutside: true,
                        closeOnEsc:          true,
                        buttons:             'ok'
                    });
                }
            }
        };
        xhr.onerror = (e) => {
            document.getElementById('overlay-loading').remove();
            swal({
                title:               'Es ist ein Fehler aufgetreten',
                text:                'Bitte versuchen Sie es erneut, oder wenden Sie sich an den Webseiten-Administrator.',
                icon:                'error',
                closeOnClickOutside: true,
                closeOnEsc:          true,
                buttons:             'ok'
            });
        };
        xhr.send(formData);
        console.log(xhr);
        CODECARD.reload(clientId);
    }
}